import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function toggleAppSearchPanelReducer(state = initialState.toggleAppSearchPanel, action) {
  switch (action.type) {
    case types.TOGGLE_APP_SEARCH_PANEL:
      return Object.assign({}, state, {
        isRelatedTransactionGridOpen: action.isRelatedTransactionGridOpen,
      });
    case types.SET_RELATED_GRID_LOADED:
      return Object.assign({}, state, {
        isRelatedTransactionGridLoaded: action.isRelatedTransactionGridLoaded,
      });
    case types.SET_DATA_SEARCH_TRANSACTION_GRID_PROP:
      return Object.assign({}, state, {
        dataTransactionGridStatus: action.dataTransactionGridStatus,
        dataSearchPrevPage: action.dataSearchPrevPage,
        dataSearchNextPage: action.dataSearchNextPage,
      });
    default:
      return state;
  }
}
